import React from 'react';
import PropTypes from 'prop-types';
import multimediaCanPauseModes from './MultimediaDisplayConstants';

class MultimediaStatusInfo extends React.Component {
    static propTypes = {
        multimediaError: PropTypes.string,
        canPause: PropTypes.bool,
        canPauseMode: PropTypes.string,
        replayTimesUid: PropTypes.string,
        repeatTimes: PropTypes.number,
        replyTimesText: PropTypes.string,
        enableResetPlayedTimes: PropTypes.bool,
        resetPlayedTimes: PropTypes.func,
        translationService: PropTypes.object,
    };

    render() {
        const {
            multimediaError,
            canPause,
            canPauseMode,
            replayTimesUid,
            repeatTimes,
            replyTimesText,
            enableResetPlayedTimes,
            resetPlayedTimes,
            translationService,
        } = this.props;
        const multimediaErrorClass = multimediaError !== '' ? 'audio-error' : 'audio-error hidden';
        const replayTimesClass = repeatTimes !== -1 ? 'replay-times-restricted' : 'replay-times-restricted hidden';
        const { t } = translationService;

        if (multimediaError !== '') {
            return (
                <div className="restrictions">
                    <span className={multimediaErrorClass}>{multimediaError}</span>
                </div>
            );
        }
        if ((canPauseMode === multimediaCanPauseModes.BASIC || canPause) && repeatTimes === -1) {
            // no restrictions
            return null;
        }
        return (
            <div className="restrictions">
                <span className="pause-restricted">{t('audio.pauseDisabled')}</span>
                <span className="replay-restricted">{t('audio.onlyPlayOnce')}</span>
                <span id={replayTimesUid} className={replayTimesClass}>{replyTimesText}</span>
                {
                    enableResetPlayedTimes ?
                        <button className="resetPlayedTimes" onClick={resetPlayedTimes}>
                            {t('audio.resetPlayedTimes')}
                        </button>
                        :
                        null
                }
            </div>
        );
    }
}

export default MultimediaStatusInfo;
